const FIELD_LABELS = {
  // Identité
  lastname: "Nom de famille",
  firstname: "Prénom",
  name: "Nom",
  gender: "Genre",
  birthday: "Date de naissance",
  age: "Âge",
  address: "Adresse",
  postal_code: "Code postal",
  city: "Ville",
  phone: "Téléphone",
  email: "Email",
  accept_contacted: "Accepte d'être contacté(e)",
  member_id: "Fiche membre de l'élève",
  // Scolarité
  training_id: "Formation",
  level_id: "Niveau",
  class_id: "Classe",
  status: "Statut",
  result: "Avis de passage",
  result_observation: "Appréciation générale",
  previous_result: "Avis de passage de l'année précédente",
  previous_result_observation: "Appréciation générale de l'année précédente",
  previous_training_name: "Formation précédente",
  previous_level_name: "Niveau de l'année précédente",
  previous_class_name: "Classe de l'année précédente",
  previous_status: "Statut de l'année précédente",
  // Inscription
  registration_new: "Nouvelle inscription",
  registration_details: "Détails de l'inscription",
  registration_feedback: "Commentaire de l'inscription",
  registration_confirmation_by_id: "Inscription confirmée par",
  registration_confirmation_date: "Date de confirmation de l'inscription",
  registration_confirmation_details: "Détails de la confirmation",
  registration_father_signature: "Signature du père",
  registration_father_signature_date: "Date de signature du père",
  registration_mother_signature: "Signature de la mère",
  registration_mother_signature_date: "Date de signature de la mère",
  accepted_internal_rules: "Règlement intérieur accepté",
  on_waiting_list_since_date: "En liste d'attente depuis le",
  on_waiting_list_details: "Détails de la mise en liste d'attente",
  unregistration_by_id: "Désinscription effectuée par",
  unregistration_date: "Date de désinscription",
  unregistration_reason: "Motif de la désinscription",
  // Parents
  parents_divorced: "Parents divorcés",
  father_id: "Père",
  father_firstname: "Prénom du père",
  father_lastname: "Nom du père",
  father_phone: "Téléphone du père",
  father_email: "Email du père",
  father_address: "Adresse du père",
  father_postal_code: "Code postal du père",
  father_city: "Ville du père",
  father_accept_contacted: "Le père accepte d'être contacté",
  mother_id: "Mère",
  mother_firstname: "Prénom de la mère",
  mother_lastname: "Nom de la mère",
  mother_phone: "Téléphone de la mère",
  mother_email: "Email de la mère",
  mother_address: "Adresse de la mère",
  mother_postal_code: "Code postal de la mère",
  mother_city: "Ville de la mère",
  mother_accept_contacted: "La mère accepte d'être contactée",
  // Autorisations et contacts
  authorized_back_alone: "Autorisé(e) à rentrer seul(e)",
  authorized_back_with: "Personnes autorisées à récupérer l'enfant après les cours",
  authorized_take_photo: "Autorisation de prise de photos",
  contact_person_1: "Contact 1",
  contact_person1: "Contact 1",
  contact_person_1_phone: "Téléphone du contact 1",
  contact_person1_phone: "Téléphone du contact 1",
  contact_person_2: "Contact 2",
  contact_person2: "Contact 2",
  contact_person_2_phone: "Téléphone du contact 2",
  contact_person2_phone: "Téléphone du contact 2",
  // Santé
  health_issues: "Problèmes de santé",
  medical_traitement: "Traitement médical",
  allergies: "Allergies",
  medical_devices: "Appareils médicaux",
  inform_change_of_situation: "Engagement à informer d'un changement de situation",
};

const STATUS_LABELS = {
  NEW: "Nouvelle candidature",
  PREREGISTRED: "Pré-inscrit(e)",
  WAITING_LIST: "Liste d'attente",
  ENROLLED: "Inscrit(e) / Confirmé(e)",
  UNREGISTRED: "Désinscrit(e)",
};

const RESULT_LABELS = {
  ONGOING: "En cours",
  PASSED: "Passage",
  FAILED: "Redoublement",
};

const GENDER_LABELS = { B: "Garçon", G: "Fille" };

const BOOLEAN_LABELS = { true: "Oui", false: "Non" };

const VALUE_LABELS = {
  status: STATUS_LABELS,
  previous_status: STATUS_LABELS,
  result: RESULT_LABELS,
  previous_result: RESULT_LABELS,
  gender: GENDER_LABELS,
};

const EMPTY_VALUE = "(vide)";
const MAX_VALUE_LENGTH = 200;

// Fields referencing another object (member, class, ...) are only readable through their "*_name" value:
// the raw identifier is never displayed.
const REFERENCE_FIELDS = /_id$/;
const UNKNOWN_REFERENCE = "—";

// "2025-06-28 10:11:48" or "2025-06-28T10:11:48Z"
const DATE_TIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/;

/**
 * Human readable (French) label of a recorded field name.
 * Unknown fields fall back to a prettified version of the technical name.
 */
export const getFieldDisplayName = (fieldName) => {
  if (!fieldName) {
    return "";
  }
  if (FIELD_LABELS[fieldName]) {
    return FIELD_LABELS[fieldName];
  }
  const text = fieldName.replace(/_id$/, "").replace(/_/g, " ").trim();
  return text.charAt(0).toUpperCase() + text.slice(1);
};

const formatDate = (value) => {
  const match = DATE_TIME_PATTERN.exec(value);
  if (!match) {
    return value;
  }
  const [, year, month, day, hours, minutes] = match;
  const date = `${day}/${month}/${year}`;
  return hours ? `${date} à ${hours}:${minutes}` : date;
};

/**
 * Whether the value of a change (`side` is "original" or "new") is empty.
 */
export const isEmptyChangeValue = (change, side) => {
  const value = change?.[`${side}_value`];
  return !change?.[`${side}_value_name`] && (value === undefined || value === null || value === "");
};

/**
 * Human readable value of a change (`side` is "original" or "new").
 */
export const formatChangeValue = (change, side) => {
  const value = change?.[`${side}_value`];
  const valueName = change?.[`${side}_value_name`];
  const fieldName = change?.field_name;

  if (valueName) {
    return valueName;
  }
  if (isEmptyChangeValue(change, side)) {
    return EMPTY_VALUE;
  }
  const mapped = VALUE_LABELS[fieldName]?.[value] ?? BOOLEAN_LABELS[value];
  if (mapped) {
    return mapped;
  }
  if (fieldName?.endsWith("_signature")) {
    return "Signature";
  }
  if (fieldName?.endsWith("_date") || fieldName === "birthday") {
    return formatDate(value);
  }
  if (REFERENCE_FIELDS.test(fieldName || "")) {
    return UNKNOWN_REFERENCE;
  }
  return value.length > MAX_VALUE_LENGTH ? `${value.slice(0, MAX_VALUE_LENGTH)}…` : value;
};
